/**
 * 动态加载js文件
 */
const loadJSFile = (jsUrl: string) =>
  new Promise((resolve, reject) => {
    const $js = document.createElement("script")
    $js.src = jsUrl
    $js.type = "text/javascript"
    $js.onload = () => {
      resolve(true)
    }
    $js.onerror = (err) => {
      console.error(err)
      reject(false)
    }
    document.body.appendChild($js)
  })

export { loadJSFile }
